import type { CountryCode } from "libphonenumber-js";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const formatPhoneForDisplay = (phone: string | undefined | null): string => {
  if (!phone) return "";

  try {
    const t = phone.split("-");
    const cleaned = `+${t[1]}${t[2]}`;
    const parsed = parsePhoneNumberFromString(cleaned, t[0] as CountryCode);
    return parsed ? parsed.formatInternational() : phone;
  } catch (error) {
    return phone;
  }
};

export const PhoneUtils = {
  format: formatPhoneForDisplay,
};
